import { Call, CallLite } from '@src/types/calls';
import { useMemo } from 'react';
import {
  callDirectionFlags,
  CallDirectionFlags,
} from './useCallDirectionFlags';
import { callStatusFlags, CallStatusFlags } from './useCallStatusFlags';

export type CallFlags = {
  isCall: boolean;
} & CallStatusFlags &
  CallDirectionFlags;

export const callFlags = (call?: Call | CallLite): CallFlags => {
  const statusFlags = callStatusFlags(call?.status);
  const directionFlags = callDirectionFlags(call?.direction);

  return {
    ...statusFlags,
    ...directionFlags,
    isCall: !!call?.id,
  };
};

const useCallFlags = (call?: Call | CallLite): CallFlags =>
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useMemo(() => callFlags(call), [call?.status, call?.direction]);

export default useCallFlags;
